const highlight = (words, query) => words.replace(query,
  `<span style="color: #b3e5fc">${query}</span>`);

export default highlight;
